import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const hasAdminRole = () =>{
  if (JSON.parse(localStorage.getItem('userData')).role.id == 2) {
    return true
  } else {
    return false
  }
}

export const hasSuperAdminRole = () =>{
  if (JSON.parse(localStorage.getItem('userData')).role.id == 1) {
    return true
  } else {
    return false
  }
}

export const hasReadPermission = (key) => {
  const index = useJwt.getPermissions().findIndex(per => per.url == key && per.crud.includes("R"))
  return index !== -1;
}

export const hasCreatePermission = (key) => {
  const index = useJwt.getPermissions().findIndex(per => per.url == key && per.crud.includes("C"))
  return index !== -1;
}

export const hasUpdatePermission = (key) => {
  const index = useJwt.getPermissions().findIndex(per => per.url == key && per.crud.includes("U"))
  return index !== -1;
}

export const hasDeletePermission = (key) => {
  const index = useJwt.getPermissions().findIndex(per => per.url == key && per.crud.includes("D"))
  return index !== -1;
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
